import React from 'react';

// 1:1 with WAL's QuoteActivitySkeleton — each row is the 55px time column, the timeline dot,
// and one or two message bars sized like a real "actor · action" line.
const ROW_BARS: string[][] = [
    ['w-[250px]', 'w-[100px]'],
    ['w-[250px]', 'w-[100px]'],
    ['w-[50px]', 'w-[310px]'],
    ['w-[250px]', 'w-[170px]'],
    ['w-[230px]'],
    ['w-[50px]', 'w-[310px]'],
    ['w-[280px]', 'w-[90px]'],
    ['w-[50px]', 'w-[260px]'],
    ['w-[210px]'],
    ['w-[250px]', 'w-[120px]'],
];

const SKELETON_GROUPS = [
    { dateWidth: 'w-[130px]', rows: ROW_BARS.slice(0, 7) },
    { dateWidth: 'w-[115px]', rows: ROW_BARS.slice(7) },
];

const ActivityFeedSkeleton = () => (
    <div className="flex flex-col animate-pulse" data-testid="activity-feed-skeleton">
        {SKELETON_GROUPS.map((group, groupIndex) => (
            <React.Fragment key={groupIndex}>
                <div className="flex items-center justify-between gap-x-2 pb-3 mb-3 border-b border-utilityGray200">
                    <div className={`h-[18px] rounded bg-utilityGray100 ${group.dateWidth}`} />
                    <div className="h-[18px] w-[70px] rounded bg-utilityGray100" />
                </div>
                <div className="relative">
                    {group.rows.map((bars, rowIndex) => (
                        <div key={rowIndex} className="relative pb-5 flex">
                            <div className="flex-none w-[55px]">
                                <div className="h-[18px] w-[50px] rounded bg-utilityGray100" />
                            </div>
                            <span className="absolute left-[70px] top-[2px] z-10 w-3 h-3 rounded-full bg-utilityGray100" />
                            <div className="pl-[42px] flex-1 min-w-0 flex gap-x-1 overflow-hidden">
                                {bars.map((width, barIndex) => (
                                    <div key={barIndex} className={`h-[18px] min-w-0 rounded bg-utilityGray100 ${width}`} />
                                ))}
                            </div>
                        </div>
                    ))}
                    <div className="absolute left-[75px] -top-3 bottom-5 w-[2px] rounded bg-utilityGray100" />
                </div>
            </React.Fragment>
        ))}
    </div>
);

export default ActivityFeedSkeleton;
